import { createReducer } from 'reduxsauce';
import { HistoryTypes } from './actions';
import { HISTORY_TYPE } from './constants';

const requestState = {
  histories: [],
  historyType: HISTORY_TYPE.ORDER,
  total: 0,
  loading: true,
  error: null
};

const INITIAL_STATE = {
  ...requestState
};

const fetchSuccess = (state = INITIAL_STATE, actions) => ({
  ...state,
  histories: actions.data.result,
  total: actions.data.total,
  historyType: actions.data.historyType,
  loading: false,
  error: null
});

const fetchFailure = (state = INITIAL_STATE, actions) => ({
  ...state,
  error: actions.error
});

export const HANDLERS = {
  [HistoryTypes.HISTORY_FETCH_FAILURE]: fetchFailure,
  [HistoryTypes.HISTORY_FETCH_SUCCESS]: fetchSuccess
};

export const historyReducer = createReducer(INITIAL_STATE, HANDLERS);
